export default __webpack_public_path__ + "static/media/abacatepay.alt.89f761d2.png";